export default __webpack_public_path__ + "static/media/LOGOBLANCO.a0bba3f9.png";